// Status classifiers used by the FE belt-and-suspenders filter that hides
// approved + queued rows while the server response catches up.
const APPROVED_REVIEW_STATUSES = new Set(["APPROVED", "MAPPED"]);

const REJECTED_REVIEW_STATUSES = new Set(["REJECTED", "IGNORED"]);

const APPROVAL_QUEUED_REVIEW_STATUSES = new Set([
  "APPROVAL_QUEUED",
  "APPROVAL_PENDING",
  "APPROVAL_IN_PROGRESS",
  "APPROVAL_RUNNING",
  "APPROVAL_SYNC_QUEUED",
  "APPROVAL_SYNCING",
  "PENDING_APPROVAL",
  "QUEUED_FOR_APPROVAL",
  "SUBMITTED_FOR_APPROVAL",
  "SYNC_QUEUED",
  "SYNCING",
]);

function normalizeReviewStatus(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const normalized = value
    .trim()
    .replace(/[\s-]+/g, "_")
    .toUpperCase();
  return normalized.length > 0 ? normalized : null;
}

export function isApprovedAttributeReviewStatus(value: unknown): boolean {
  const normalized = normalizeReviewStatus(value);
  return normalized ? APPROVED_REVIEW_STATUSES.has(normalized) : false;
}

export function isApprovalQueuedAttributeReviewStatus(value: unknown): boolean {
  const normalized = normalizeReviewStatus(value);
  return normalized ? APPROVAL_QUEUED_REVIEW_STATUSES.has(normalized) : false;
}

export function isRejectedAttributeReviewStatus(value: unknown): boolean {
  const normalized = normalizeReviewStatus(value);
  return normalized ? REJECTED_REVIEW_STATUSES.has(normalized) : false;
}

export function isActionableAttributeReviewStatus(value: unknown): boolean {
  return (
    !isApprovedAttributeReviewStatus(value) &&
    !isApprovalQueuedAttributeReviewStatus(value) &&
    !isRejectedAttributeReviewStatus(value)
  );
}
